import { HttpService } from "@/core/services/http.service";

export class TicketCallBackService {
  static useAddCallBack() {
    const api = (id, data) =>
      HttpService.axios({
        method: "POST",
        url: `/ticket/addCallBack/${id}`,
        data,
      });
    return HttpService.useRequest<any>(api);
  }
}
